import { useMemo } from 'react';
import { useActiveOrganization } from '@hooks';
import { createTimezoneAwareDateFormatters, convertUtcToTimezone } from '@utils';

/**
 * Hook that provides timezone-aware date formatting functions
 * based on the active organization's timezone setting.
 */
export const useTimezoneAwareDateFormatters = () => {
  const activeOrganization = useActiveOrganization();
  
  const organizationTimezone = useMemo(() => {
    return activeOrganization?.timezone || 'UTC';
  }, [activeOrganization?.timezone]);

  const formatters = useMemo(() => {
    return createTimezoneAwareDateFormatters(organizationTimezone);
  }, [organizationTimezone]);

  return {
    ...formatters,
    organizationTimezone,
    convertUtcToTimezone: (utcDatetime: string) => convertUtcToTimezone(utcDatetime, organizationTimezone),
  };
};

/**
 * Hook that provides the current organization's timezone
 */
export const useOrganizationTimezone = () => {
  const activeOrganization = useActiveOrganization();
  return activeOrganization?.timezone || 'UTC';
};
